<template>
  <div class="md-layout"  v-resize="onResize">
    <draggable v-if="!isMobile" v-model="myArray" class="md-layout" style="width:100%">
        <genericErrorLog v-for="(type, i ) in types_arr" :key="i" :item="type" />
    </draggable>
    <div v-else style="width: 100%">
        <genericErrorLog v-for="(type, i ) in types_arr" :key="i" :item="type" />
    </div>
    <gerallogs />
  </div>
</template>
<script>
import draggable from "vuedraggable";
import gerallogs from "../components/LogsEMS/gerallogs";
import genericErrorLog from "../components/LogsEMS/genericErrorLog";
import * as Logs from "../providers/logs.service";
export default {
  components: {
    draggable,
    gerallogs,
    genericErrorLog
  },
  data() {
    return {
      types_arr: [],
      isMobile: false
    };
  },
  created() {
    var self = this;
    Logs.getLogsTypes().then(r => {
      self.types_arr = Object.assign({}, r);
    });
  },
  methods: {
     onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>
<style>
.configicon {
}
</style>